import React from "react";
import { slugify } from "../../../utils";
import { Link } from "react-router-dom";

const SidebarTag = ({ data }) => {
  if (!data || !Array.isArray(data)) return null;

  const allTags = data.flatMap((item) => item.tags || []);

  // Get unique tags
  const uniqueTagsMap = {};
  allTags.forEach((tag) => {
    const trimmedTag = tag.trim();
    const slug = slugify(trimmedTag);
    if (!uniqueTagsMap[slug]) uniqueTagsMap[slug] = trimmedTag;
  });

  const uniqueTags = Object.entries(uniqueTagsMap).map(([slug, title]) => ({
    slug,
    title,
  }));

  return (
    <ul className="tagcloud">
      {uniqueTags.map((tag) => (
        <Link key={tag.slug} to={`${process.env.PUBLIC_URL}/tag/${tag.slug}`}>
          {tag.title}
        </Link>
      ))}
    </ul>
  );
};

export default SidebarTag;
